export function stringToNumberHash(id: string = "") {
  const hashNumber = id
    ? id.split("").reduce((hash, char) => hash + char.charCodeAt(0), 0)
    : 0;
  return hashNumber;
}
